import React from 'react';
import { CSVLink } from 'react-csv';
import { IInitialState } from '../../../../../../redux/duck/legado/limitApp/interface/reduxInterfaces';
import DownloadButton from '../../../../../../shared/components/buttons/DownloadButton';
import Csv from '../../../../../../shared/components/icons/Csv';

function ExportCsv(props: IInitialState) {
  const header = [
    { label: 'ID', key: 'id' },
    { label: 'Nome', key: 'companyName' },
    { label: 'Cpf/Cnpj', key: 'cnpjCpf' },
    { label: 'Parceiro', key: 'partner' },
    { label: 'Formato de Conta', key: 'accountFormat' },
    { label: 'Telefone', key: 'cel' },
    { label: 'E-mail', key: 'email' },
    { label: 'Agência', key: 'agency' },
    { label: 'Conta', key: 'account' },
    { label: 'Digito', key: 'digit' },
    { label: 'Tipo de Limite', key: 'type' },
    { label: 'Data de referência', key: 'referenceDate' },
    { label: 'Valor do Débito', key: 'value' },
  ];

  return (
    <CSVLink
      data={props.limits}
      headers={header}
      filename="lista_de_clientes.csv">
      <DownloadButton>
        <Csv />
      </DownloadButton>
    </CSVLink>
  );
}

export default ExportCsv;
